import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

const useBranches = () => {
  const [branches, setBranches] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getBraches() {
      try {
        const branch = await dataProvider.getList("merchant-branches", {});
        setBranches(branch.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getBraches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { branches, loading, error };
};

export default useBranches;
